export const IStorageDataSourceType = Symbol('IStorageDataSource');
